/*---------------------------------------------------------*\
 * Imports
 \*---------------------------------------------------------*/
import PubSub from 'pubsub-js';
import _ from 'lodash';

/*---------------------------------------------------------*\
 * Constants
 \*---------------------------------------------------------*/
const TOPICS = new WeakMap();
const TIMEOUT = new WeakMap();

/*---------------------------------------------------------*\
 * MapGalleryController
 \*---------------------------------------------------------*/
class MapGalleryController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($scope, $interval, topics, $timeout) {
    TOPICS.set(this, topics);
    TIMEOUT.set(this, $timeout);

    this.name = 'mapGallery';
    this.$interval = $interval;
    this.$scope = $scope;
    this.url = 'http://images.itv.traffic.news12.com/';

    let promise;
    const start = (array, currentIndex) => {
      if (promise) {
        this.$interval.cancel(promise);
      }
      let nextIndex = currentIndex + 1;
      promise = this.$interval(() => {
        this.selectImage(nextIndex);
        nextIndex++;
      }, 6000);
    };

    this.$onInit = () => {
      TIMEOUT.get(this)(() => {
        this.selectImage(0);
        start(this.maps, 0);
      }, 100);
    };

    PubSub.subscribe(TOPICS.get(this).component.slideshowToggle, (msg, data) => {
      if (!data.pausemapOn) {
        this.resetSlideshow();
      } else if (data.pausemapOn) {
        this.$interval.cancel(promise);
      }
      this.pausemapOn = data.pausemapOn;
    });

    this.resetSlideshow = () => {
      this.$interval.cancel(promise);
      start(this.maps, this.selIndex);
    };

    this.$scope.$on('$destroy', () => {
      this.$interval.cancel(promise);
    });
  }

  //-----------------------------------
  // Lifecycle
  //-----------------------------------
  $postLink() {
    this.selectImage(0);
  }

  //-----------------------------------
  // Methods
  //-----------------------------------

  selectImage(index) {
    if (index < 0) {
      return;
    }

    // Create temporary image attribute so we can load the image and display
    // loading while it is coming in.
    const img = document.createElement('img');

    this.selIndex = index;

    this.loading = true;
    this.error = false;

    img.addEventListener('load', () => {
      this.loading = false;
      this.$scope.$apply();
    });

    img.addEventListener('error', () => {
      this.error = true;
      this.loading = false;
      this.$scope.$apply();
    });

    if (!_.isUndefined(this.maps)) {
      img.src = this.url + this.maps[this.selIndex % this.maps.length].csign + '.jpg';
    }
    this.mapimage = img.src;
  }

  resetSlideshow() {
    this.$interval.cancel(this.promise);
    this.start(this.maps, this.selIndex);
  }
}

MapGalleryController.$inject = [
  '$scope',
  '$interval',
  'topics',
  '$timeout'
];

export default MapGalleryController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/mapGallery/mapGallery.controller.js
 **/